import { Schema, MarkType } from 'prosemirror/model';
import { schema } from 'prosemirror/schema-basic';
import {
  LowerRomanList,
  UpperRomanList,
  LowerAlphaList,
  UpperAlphaList,
} from './StyleableList';

import AmItem from './AmItem';

export { AmItem };

export class SuperscriptMark extends MarkType {
  get matchDOMTag() {
    return { sup: null };
  }
  toDOM() {
    return ['sup'];
  }
}

export class SubscriptMark extends MarkType {
  get matchDOMTag() {
    return { sub: null };
  }
  toDOM() {
    return ['sub'];
  }
}

export class UnderlineMark extends MarkType {
  get matchDOMTag() {
    return { u: null };
  }
  toDOM() {
    return ['u'];
  }
}

export default new Schema({
  nodes: schema.nodeSpec
    .addToEnd('amItem', {
      type: AmItem,
      group: 'inline',
    })
    .addToEnd('lower_roman_list', {
      type: LowerRomanList,
      content: 'list_item+',
      group: 'block',
    })
    .addToEnd('upper_roman_list', {
      type: UpperRomanList,
      content: 'list_item+',
      group: 'block',
    })
    .addToEnd('lower_alpha_list', {
      type: LowerAlphaList,
      content: 'list_item+',
      group: 'block',
    })
    .addToEnd('upper_alpha_list', {
      type: UpperAlphaList,
      content: 'list_item+',
      group: 'block',
    }),
  marks: schema.markSpec
    .addToEnd('sup', SuperscriptMark)
    .addToEnd('sub', SubscriptMark)
    .addToEnd('u', UnderlineMark),
});
